import React from 'react';

function GlobalSettings(props) {
    return (
        <div></div>
    );
}

export default GlobalSettings;